import { render } from "./InstancesWrapper.vue?vue&type=template&id=6442944e"
import script from "./InstancesWrapper.vue?vue&type=script&lang=js"
export * from "./InstancesWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__